module.exports = "/static/assets/d2c646eaa2c55f306468b28d7cedd554.png";